.startWrapper {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
}

.tooltipIcon {
  color: var(--color-semantic-text-neutral30);
  transform: rotate(180deg);
  cursor: pointer;
}
